export default __webpack_public_path__ + "static/media/GoRight-Light.e23978f4.svg";